import { Pipe, PipeTransform } from '@angular/core';
import { SelectableItem } from './models/selectable-item';

@Pipe({ name: 'itemPipe' })
export class ItemPipe implements PipeTransform {
  public transform(value: SelectableItem[], ...arg: any[]) {
    // ES6 array destructuring
    let ret = value.filter((item) => item.matchFilter);
    if (arg.toString() !== '' && ret.length > 0) {
      ret.map(opt => opt.isOpen = true);
    } else {
      ret.map(opt => opt.isOpen = false);
    }
    return ret;
  }
}
